module.exports = __webpack_public_path__ + "img/pr-8.5aa85a44.png";